import registrationService from '../registration-hosting-service.js';

export default {
  data() {
    return {
      ruleForm: {
        inAcct: '',
        inMemo: '',
        inAmount: ''
      }
    };
  },
  methods: {
    submit() {
      registrationService.addCcbInAcc(this.ruleForm).then(res => {
        if (res && res.code === '0') {
          console.log(res);
          alert('成功了啊');
        }
      });
    }
  }
};
